import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    fontSize: 18,
    textAlign: 'center',
  },
  mainContentBox: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 6,
    padding: theme.spacing(0, 2),
    boxShadow: '0px 3px 6px #00000029',
  },
  mainFeaturesBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '25px',
  },
  titleFeatures: {
    color: COLOR_PURPLE,
    fontSize: 15,
    padding: theme.spacing(1, 0),
    fontWeight: 'bold',
    lineHeight: 1.2,
  },
  subTitleFeatures: {
    fontSize: 12,
  },
}));
